import { SvgIcon } from "@mui/material";
import type { DualIconProps } from "shared/types/common";

export const SlaTargetIcon = ({
  primaryColor = "#5563F5",
  secondaryColor = "#B7BDFB",
  activePrimaryColor,
  activeSecondaryColor,
  active = false,
  ...props
}: DualIconProps) => {
  const actPrimary = activePrimaryColor ?? primaryColor;
  const actSecondary = activeSecondaryColor ?? secondaryColor;

  const strokeColor = active ? actPrimary : primaryColor;
  const fillColor = active ? actSecondary : secondaryColor;

  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" role="img" aria-label="SLA target">
        <path
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M7.334 2.647a5.682 5.682 0 1 0 6.02 6.02"
        />
        <path
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M10.807 8.667a3.151 3.151 0 1 1-3.474-3.475M9.362 6.64 7.687 8.314"
        />
        <path
          fill={fillColor}
          fillRule="evenodd"
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M9.336 3.999v2.668h2.668l2.668-2.668-1.78-.89-.888-1.778L9.336 4Z"
          clipRule="evenodd"
        />
      </svg>
    </SvgIcon>
  );
};
